import "../css/Reader.css";
import { Character } from "../../shared/types/Character";

type Props = {
  characters: Character[];
};

const ListCharacters = (props: Props) => {
  const { characters } = props;

  if (characters.length === 0) return null;

  const renderRow = (c: Character, index: number) => {
    const name = c.displayName || c.name;
    const isNarrateur = name.toUpperCase() === "NARRATEUR";
    const stats = [
      c.bulles !== undefined ? `${c.bulles} bulle${c.bulles > 1 ? "s" : ""}` : null,
      c.definitions ? `${c.definitions} mot${c.definitions > 1 ? "s" : ""} du dico` : null,
    ].filter(Boolean);

    return (
      <li key={`${c.name}-${index}`} className="rd-character">
        <span className="rd-character__avatar" style={!c.img && c.color ? { backgroundColor: c.color } : undefined}>
          {c.img ? (
            <img src={`https://newbrand.s3.eu-west-3.amazonaws.com/personnages/${c.img}`} alt="" loading="lazy" />
          ) : (
            name.charAt(0).toUpperCase()
          )}
        </span>
        <span className="rd-character__info">
          <span
            className="rd-character__name"
            style={{
              backgroundColor: c.color || "#E8E8E8",
              color: isNarrateur || !c.color ? "#333333" : "#F1F1F1",
            }}
          >
            {name.toUpperCase()}
          </span>
          {stats.length > 0 ? <span className="rd-character__stats">{stats.join(" · ")}</span> : null}
        </span>
      </li>
    );
  };

  return (
    <section className="rd-section" aria-labelledby="rd-characters-title">
      <h2 id="rd-characters-title" className="rd-section__title">
        Personnages de l'épisode
        <span className="rd-section__count">{characters.length}</span>
      </h2>
      <ul className="rd-characters">{characters.map(renderRow)}</ul>
    </section>
  );
};

export default ListCharacters;
